(() => {
  window.addEventListener("abra:announced", () => {
    setTimeout(() => {
      const sellingPlanContainer = document.querySelectorAll(
        ".sls-option-container.seal-table"
      );

      sellingPlanContainer.forEach((container) => {
        container.addEventListener("click", (event) => {
          if (!container.classList.contains("sls-active")) {
            if (container.hasAttribute("data-selling-plan-group-id")) {
              window.Abra.useSellingPlanPriceOnProductBlock = true;
            } else {
              window.Abra.useSellingPlanPriceOnProductBlock = false;
            }
          }

          window.dispatchEvent(new CustomEvent("abra:render"));
        });
      });
    }, 1000);
  });
})();
